// import { getDomainAndPort } from '../api/Utils';

export const getLangFromLocalStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('language');
  }
  return 'fa';
};

export const setLangToLocalStorage = (lang: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem('language', lang);
  }
};
// const defaultLang = getDomainAndPort().domainFeatures?.defaultLang;
// const defaultLang = 'fa';
export const getDefaultTimeZoneLang = () => {
  // const date = new Date();
  // const iranOffsetMinutes = -210;
  // return defaultLang || date.getTimezoneOffset() === iranOffsetMinutes
  //   ? 'fa'
  //   : 'en';
  return 'fa';
};

export const getLanguageBaseOnTZ = () => {
  const langFromLocalStorage = getLangFromLocalStorage();
  if (langFromLocalStorage) {
    return langFromLocalStorage;
  } else {
    return getDefaultTimeZoneLang();
  }
};
